import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOwnClaimsWithSetupPendingQueryVariables = Types.Exact<{
  status: Types.Scalars['String']['input'];
}>;


export type GetOwnClaimsWithSetupPendingQuery = { __typename?: 'query_root', authority_claims: Array<{ __typename?: 'authority_claims', id: any, setup_meeting_prompted_at?: any | null }> };


export const GetOwnClaimsWithSetupPendingDocument = gql`
    query GetOwnClaimsWithSetupPending($status: String!) {
  authority_claims(
    where: {status: {_eq: $status}, jurisdiction: {setup_completed: {_eq: false}}}
    limit: 1
  ) {
    id
    setup_meeting_prompted_at
  }
}
    `;

/**
 * __useGetOwnClaimsWithSetupPendingQuery__
 *
 * To run a query within a React component, call `useGetOwnClaimsWithSetupPendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnClaimsWithSetupPendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnClaimsWithSetupPendingQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetOwnClaimsWithSetupPendingQuery(baseOptions: Apollo.QueryHookOptions<GetOwnClaimsWithSetupPendingQuery, GetOwnClaimsWithSetupPendingQueryVariables> & ({ variables: GetOwnClaimsWithSetupPendingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnClaimsWithSetupPendingQuery, GetOwnClaimsWithSetupPendingQueryVariables>(GetOwnClaimsWithSetupPendingDocument, options);
      }
export function useGetOwnClaimsWithSetupPendingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnClaimsWithSetupPendingQuery, GetOwnClaimsWithSetupPendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnClaimsWithSetupPendingQuery, GetOwnClaimsWithSetupPendingQueryVariables>(GetOwnClaimsWithSetupPendingDocument, options);
        }
export function useGetOwnClaimsWithSetupPendingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnClaimsWithSetupPendingQuery, GetOwnClaimsWithSetupPendingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnClaimsWithSetupPendingQuery, GetOwnClaimsWithSetupPendingQueryVariables>(GetOwnClaimsWithSetupPendingDocument, options);
        }
export type GetOwnClaimsWithSetupPendingQueryHookResult = ReturnType<typeof useGetOwnClaimsWithSetupPendingQuery>;
export type GetOwnClaimsWithSetupPendingLazyQueryHookResult = ReturnType<typeof useGetOwnClaimsWithSetupPendingLazyQuery>;
export type GetOwnClaimsWithSetupPendingSuspenseQueryHookResult = ReturnType<typeof useGetOwnClaimsWithSetupPendingSuspenseQuery>;
export type GetOwnClaimsWithSetupPendingQueryResult = Apollo.QueryResult<GetOwnClaimsWithSetupPendingQuery, GetOwnClaimsWithSetupPendingQueryVariables>;